import Vue from 'vue';
import mock from '@/globals/mock.json';
import { Component } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import { USER_DETAILS } from '@/types/authentication.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { UserDetails } from '@/models/UserDetails.model';
import {
  RESET_EMPLOYEES_FORMS_SEARCH_OBJECT,
  SET_CUBE_DETAILS,
  SET_CUBE_SEARCH_OBJECT,
} from '@/types/managerForm.types';
import { Grid } from '@/models/Grid.model';
import { Form101SearchModel } from '@/models/Form101Search.model';

@Component({})
export default class MenuComponent extends Vue {

  @Mutation(RESET_EMPLOYEES_FORMS_SEARCH_OBJECT, StoreNamespace.MANAGER) public resetEmployeesFormsSearchObject;
  @Mutation(SET_CUBE_DETAILS, StoreNamespace.MANAGER) public setCubeDetails;
  @Mutation(SET_CUBE_SEARCH_OBJECT, StoreNamespace.MANAGER) public setCubeSearchObject;

  @Getter(USER_DETAILS, StoreNamespace.AUTHENTICATION) public userDetails!: UserDetails;

  public Mock: any = mock;
  public mainMenu: any = [];
  public activeItem: string = 'lobby';

  public mounted() {
    this.activeItem = this.$route.name || 'lobby';
    this.mainMenu = this.Mock.mainMenu;

    // if back button is pressed
    window.onpopstate = () => {
      this.activeItem = window.location.pathname.substr(1);
    };
    /* Doesn't work properly, but why? */
    // const header = document.querySelector('header');
    // const headerHeight = header!.offsetHeight;
    // const root = document.documentElement;
    // root.style.setProperty('--header-height', headerHeight + 'px');
  }

  public isActive(menuName: string): boolean {
    if (menuName === this.$route.name) {
      this.activeItem = menuName;
      return true;
    } else if (menuName === this.activeItem) {
      return true;
    }
    return false;
  }

  public navigateTo(menu: any) {
    if (menu.name === 'search-employees' && this.$route.name !== 'search-employees') {
      this.resetEmployeesFormsSearchObject();
    }
    if (menu.name === 'update-employees-details' && this.$route.name !== 'update-employees-details') {
      this.resetEmployeesFormsSearchObject();
      this.setCubeDetails({} as Grid);
      this.setCubeSearchObject({} as Form101SearchModel);
    }
    this.$router.push({ name: menu.name });
    // this.activeItem = menu.name === this.$route.name ? ;
  }

  public menuHaveRole(menu): boolean {
    for (const role of this.userDetails.userRoles) {
      if (menu.userRoles.indexOf(role) > -1) {
        return true;
      }
    }
    return false;
  }

}

